<template>
    <div ref="map" class="map">
        <slot></slot>
    </div>
</template>

<script>
import Map from 'ol/Map'
import { register } from 'ol/proj/proj4'
import { Attribution } from 'ol/control'

import { getDefinitions } from '../../utils/projections'

const attribution = new Attribution({
    collapsible: false,
})

export default {
    name: 'Map',
    data() {
        return {
            map: new Map({
                controls: [attribution],
            }),
        }
    },
    setup() {
        register(getDefinitions())
    },
    mounted() {
        this.map.setTarget(this.$refs['map'])

        this.map.on('pointermove', (e) => {
            if (e.dragging) {
                return
            }

            const pixel = this.map.getEventPixel(e.originalEvent)
            const hit = this.map.hasFeatureAtPixel(pixel, {
                layerFilter: (layer) => layer.get('selectable'),
            })
            this.map.getTarget().style.cursor = hit ? 'pointer' : ''
        })
    },
    provide() {
        return {
            map: this.map,
        }
    },
}
</script>

<style scoped>
.map {
    width: 100%;
    height: 100%;
}

.map ::v-deep(.ol-attribution) {
    position: absolute;
    padding: 2px;
    background: rgba(255, 255, 255, 0.7);
    text-align: right;
    display: flex;
    flex-flow: row-reverse;
    align-items: center;
    bottom: 0;
    right: 0;
    border-radius: 4px 0 0;
}

.map ::v-deep(.ol-unselectable) {
    user-select: none;
}

.map ::v-deep(.ol-attribution.ol-uncollapsible) button {
    display: none;
}

.map ::v-deep(.ol-attribution) ul {
    margin: 0;
    padding: 1px 0.5em;
    color: #333;
    text-shadow: 0 0 2px #fff;
    font-size: 10px;
}
</style>
